// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ_PACKAGE_SIZE_DETAIL_DEFAULT_LARGE = "Max 3 kg, \u0160+V+H \u2264 250 cm, max strana \u2264 100 cm, box 69 x 58 x 45 cm";
export const BZ_PACKAGE_SIZE_DETAIL_DEFAULT_MEDIUM = "Max 2 kg, \u0160+V+H \u2264 250 cm, max strana \u2264 100 cm, box 69 x 58 x 45 cm";
export const BZ_PACKAGE_SIZE_DETAIL_DEFAULT_SMALL = "(mal\u00fd bal\u00edk)";
export const BZ_PACKAGE_SIZE_DETAIL_FOOTWEAR_LARGE = "(\u0165a\u017e\u0161ie top\u00e1nky, v\u00e4\u010d\u0161ie \u010di\u017emy)";
export const BZ_PACKAGE_SIZE_DETAIL_FOOTWEAR_MEDIUM = "(tenisky, baler\u00ednky, top\u00e1no\u010dky)";
export const BZ_PACKAGE_SIZE_LARGE_detail = "Ve\u013ek\u00e1 %(detail)s";
export const BZ_PACKAGE_SIZE_MEDIUM_detail = "Stredn\u00e1 %(detail)s";
export const BZ_PACKAGE_SIZE_SMALL_detail = "Mal\u00e1 %(detail)s";
